// extracted by mini-css-extract-plugin
export default {"onion":"Onion_onion__3X46d"};